/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Cancel_TitleInputs */

const en_settings_cancel_title = /** @type {(inputs: Settings_Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel subscription?`)
};

const id_settings_cancel_title = /** @type {(inputs: Settings_Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batalkan langganan?`)
};

/**
* | output |
* | --- |
* | "Cancel subscription?" |
*
* @param {Settings_Cancel_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_cancel_title = /** @type {((inputs?: Settings_Cancel_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Cancel_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_cancel_title(inputs)
	return en_settings_cancel_title(inputs)
});